<template>
    <div class="space-y-12">
        <div class="relative">
            <img
                :src="bannerImage"
                alt="allegro EXCEL banner"
                class="w-full min-h-120 object-cover"
                @error.native="bannerImageError = true"/>
            <div v-if="content.home_banner_copy" class="absolute inset-0 flex items-center">
                <div class="container" v-html="content.home_banner_copy"/>
            </div>
        </div>

        <div class="container text-lg text-teal-dark">
            <div v-html="content.home_intro" class="space-y-6"/>
        </div>

        <CourseSearch/>

        <div class="py-24 container">
            <div class="prose max-w-none">
                <h2 class="text-center">Upcoming Courses</h2>
            </div>

            <div class="grid gap-8 mt-12 md:gap-16 lg:grid-cols-2">
                <CourseCard v-for="course in courses" :key="course.id" :course="course"/>
            </div>
        </div>
    </div>
</template>

<script>

import axios from "axios";
import CourseCard from "@/Components/CourseCard";
import CourseSearch from "@/Components/CourseSearch";
import {mapGetters} from "vuex";

export default {

    name: "HomePage",

    data() {
        return {
            courses: []
        };
    },

    async created() {
        this.fetchCourses();
    },

    components: {
        CourseCard,
        CourseSearch
    },

    methods: {
        fetchCourses() {
            axios.get(route('api.courses.index'), {
                params: {
                    upcoming: true,
                    sort: 'next_start_date',
                    per_page: 4
                }
            })
                .then((response) => {
                    this.courses = response.data.data;
                })
                .catch(console.error)
        },
    },

    computed: {
        ...mapGetters([
            'content'
        ]),
        bannerImage() {
            if (this.content.home_banner && this.content.home_banner.url) {
                return this.content.home_banner.url;
            }

            return '/images/banner.jpg';
        },
    },
};

</script>
